import { useState } from "react";
import { toast } from "sonner";
import { Download, Loader2 } from "lucide-react";
import { api, formatApiError } from "../../../booking/api";
import { Button } from "../../../components/ui/button";
import * as SITE_DATA from "@/data/site";

const collectUrls = (v, path, out) => {
  if (typeof v === "string" && /^(https?:)?\/\//.test(v)) out.push({ url: v, found_in: path });
  else if (Array.isArray(v)) v.forEach((x, i) => collectUrls(x, `${path}[${i}]`, out));
  else if (v && typeof v === "object") Object.entries(v).forEach(([k, x]) => collectUrls(x, `${path}.${k}`, out));
};

export const ExportButton = () => {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const r = await api.get("/api/admin/export");
      const site = [];
      collectUrls(SITE_DATA, "website", site);
      const data = { ...r.data, website_files: [...new Map(site.map((f) => [f.url, f])).values()] };
      const url = URL.createObjectURL(new Blob([JSON.stringify(data, null, 2)], { type: "application/json" }));
      const a = document.createElement("a");
      a.href = url;
      a.download = `tribe-export-${data.exported_at.slice(0, 16).replace(/[-:T]/g, "")}.json`;
      a.click();
      URL.revokeObjectURL(url);
      toast.success("Export downloaded");
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Button variant="outline" onClick={run} disabled={busy} data-testid="settings-export-btn" className="bg-white text-stone-900 border-stone-300 hover:bg-stone-100">
      {busy ? <Loader2 size={15} className="mr-2 animate-spin" /> : <Download size={15} className="mr-2" />} Download full export
    </Button>
  );
};
